var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal__overlay"}),_c('div',{class:[
      'modal__centered',
      {
        'modal__centered--big': _vm.big,
        'modal__centered--medium': _vm.medium,
        'modal__centered--auto': _vm.auto,
      } ]},[(!_vm.persistent)?_c('Close',{on:{"click":function($event){return _vm.$emit('close')}}}):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }